import {
  AttendanceReasonAndSubReason,
  AttendanceReasonAndSubReasonNormalized,
} from '@/modules/attendance/entities/interfaces';
import { get } from 'lodash';

export const normalizeReasonAndSubReasonResponse = (
  reasonAndSubReason: AttendanceReasonAndSubReason,
): AttendanceReasonAndSubReasonNormalized => {
  const reason = get(reasonAndSubReason, 'reason.values', null);
  const subReasonsController = get(reasonAndSubReason, 'subReason.controllerValues', null);
  const subReason = get(reasonAndSubReason, 'subReason.values', null);

  return {
    reason,
    subReasonsController,
    subReason,
  };
};
